import { render, staticRenderFns } from "./ScrollPagination.vue?vue&type=template&id=42c42d7c&"
import script from "./ScrollPagination.vue?vue&type=script&lang=js&"
export * from "./ScrollPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports